import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import 'rxjs/add/observable/of';
import { RemoteApiService } from '../core';

export interface SilenceDetectionDto {
    stationName: string;
    segmentStartDateTime: string;
    segmentEndDateTime: string;
    loggedTimeStamp: string;
    secondsOfSilence: number;
}

export interface SilenceDetectionApiResult {
    silenceDetectionDtoList: SilenceDetectionDto[];
    page: number;
    totalRows: number;
}


@Injectable()
export class SilenceLogsService {

    constructor(private remoteApi: RemoteApiService) { }

    findLogs(criteria: string,
        sortKey: string,
        sortOrder = 'ASC',
        pageNumber: number = 1,
        pageSize: number = 10): Observable<SilenceDetectionApiResult> {

        const parameters: any = {
            maxRows: pageSize,
            page: pageNumber
        };    
        if (sortKey) {
            parameters.sortKey = sortKey;
        }

        if (sortOrder) {
            parameters.order = sortOrder;
        }

        return this.remoteApi.getSilenceLogs<SilenceDetectionApiResult>(`/silence-detected`, parameters);
    }
}
